var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"importer-content"},[_c('iframe',{ref:"frame",staticClass:"esign-iframe",attrs:{"src":_vm.esignUrl},on:{"load":_vm.iframeUrlChanged}})])
}
var staticRenderFns = []

export { render, staticRenderFns }